module.exports = __webpack_public_path__ + "img/bg_03.b8715408.png";